/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tag-tree.vue?vue&type=template&id=4f5cd0e8&scoped=true&"
import script from "./tag-tree.vue?vue&type=script&lang=js&"
export * from "./tag-tree.vue?vue&type=script&lang=js&"
import style0 from "./tag-tree.vue?vue&type=style&index=0&id=4f5cd0e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cd0e8",
  null
  
)

export default component.exports